<div class="top-wr">
    <ozm-header>

    </ozm-header>
</div>
<form class="compact mx-3" #AppliForm="ngForm" (ngSubmit)="appliSubmit()">
    <div class="form-group row">
        <label class="col-sm-2 col-form-label">Name</label>
        <div class="col-sm-10">
            <input type="text" class="form-control" name="name" placeholder="Enter value here" [(ngModel)]="appli.name">
        </div>
    </div>
    <div class="form-group row">
        <label class="col-sm-2 col-form-label">Category</label>
        <div class="col-sm-10 select">
            <select class="form-control" name="category" [(ngModel)]="appli.category" (ngModelChange)="onCategoryChange()">
                <option value=""></option>
                <option *ngFor="let category of categories">{{category.name}}</option>
            </select>
        </div>
    </div>
    <div class="form-group row">
        <label class="col-sm-2 col-form-label">Sub Category</label>
        <div class="col-sm-10 select">
            <select class="form-control" name="subcategory" [(ngModel)]="appli.subCategory" (ngModelChange)="onSubCategoryChange()">
                <option value=""></option>
                <option *ngFor="let subCatsFiltered of subCategories">{{subCatsFiltered.name}}</option>
            </select>
        </div>
    </div>

    <div class="form-group row">
        <label class="col-sm-2 col-form-label">Icon</label>
        <div class="col-sm-10">
            <input type="text" class="form-control" name="icon" placeholder="Enter value here" [(ngModel)]="appli.icon">
        </div>
    </div>
    <fieldset class="form-group">
        <div class="row">
            <legend class="col-form-label col-sm-2 pt-0"></legend>
            <div class="form-check">
                <input type="checkbox" id="openByPackageName" name="openByPackageName"
                    [(ngModel)]="appli.openByPackageName">
                <label for="active">Open by package name logic</label>
            </div>
        </div>
    </fieldset>

    <div class="form-group row" *ngIf="appli.openByPackageName">
        <label class="col-sm-2 col-form-label">Package Name</label>
        <div class="col-sm-10">
          <input class="form-control" type="text" name="packageName" [(ngModel)]="appli.packageName">
        </div>
    </div>
    <div class="form-group row" >
        <label class="col-sm-2 col-form-label">Link</label>
        <div class="col-sm-10">
          <input class="form-control" type="text" name="link" [(ngModel)]="appli.link">
        </div>
    </div>
    <div class="form-group row" >
        <label class="col-sm-2 col-form-label">Fallback Url</label>
        <div class="col-sm-10">
          <input class="form-control" type="text" id="fallbackUrl" name="fallbackUrl" [(ngModel)]="appli.fallbackUrl">
        </div>
    </div>
    <div class="form-group row" >
        <label class="col-sm-2 col-form-label">Fallback Url 2</label>
        <div class="col-sm-10">
          <input class="form-control" type="text" id="fallbackUrl2" name="fallbackUrl2" [(ngModel)]="appli.fallbackUrl2">
        </div>
    </div>
    <div class="form-group row" >
        <label class="col-sm-2 col-form-label">Android image url</label>
        <div class="col-sm-10">
          <input class="form-control" type="text" id="androidImageUrl" name="androidImageUrl" [(ngModel)]="appli.androidImageUrl">
        </div>
    </div>
    <div class="form-group row" >
        <label class="col-sm-2 col-form-label">Order</label>
        <div class="col-sm-10">
          <input class="form-control" type="number" id="order" name="order" [(ngModel)]="appli.order">
        </div>
    </div>
    <fieldset class="form-group">
        <div class="row">
            <legend class="col-form-label col-sm-2 pt-0"></legend>
            <div class="form-check">
                <input type="checkbox" id="active" name="active"
                    [(ngModel)]="appli.active">
                <label for="active">Active</label>
            </div>
            <div class="form-check">
                <input type="checkbox" id="default" name="default"
                    [(ngModel)]="appli.default">
                <label for="default">Default App</label>
            </div>
        </div>
    </fieldset>

    <a class="btn btn-primary mx-3 px-3" routerLink="/appli-list">
        <span class="nav-text">Back</span>
    </a>
    <span *ngIf="appli._id !== undefined; else addButton">
        <button type="submit" class="btn btn-primary mx-3 px-3">Update</button>
        <button type="button" class="btn btn-primary mx-3 px-3" (click)="deleteAppli()">Delete</button>
    </span>
    <ng-template #addButton>
        <button type="submit" class="btn btn-primary mx-3 px-3">Add</button>
    </ng-template>
</form>
